import { CountrySelect } from '@components'

import { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { useCustomerForm } from '../../../../contexts/customerFormContext'
import { useUpdateDependentCustomerFormValues } from '../../../../hooks/useUpdateDependentCustomerFormValues'
import { AddressInputFieldProps } from '../../types/addressInputFieldProps'

type AddressCountryProps = AddressInputFieldProps

export const AddressCountry = ({ isDisabled = false }: AddressCountryProps): ReactElement => {
  const { t } = useTranslation()
  const { handleAddressCountryChange } = useUpdateDependentCustomerFormValues()
  const { customerForm } = useCustomerForm()
  const { FormItem } = customerForm

  const handleAddressCountrySelect = useCallback(
    (countryId?: string) => {
      handleAddressCountryChange(countryId)
    },
    [handleAddressCountryChange],
  )

  return (
    <FormItem
      label={t('customer_modal.form.address.country.label')}
      name="address.country"
      render={({ field: { value, onChange, ...rest } }) => (
        <CountrySelect
          {...rest}
          disabled={isDisabled}
          dropdownSize="fitTrigger"
          onSelect={(id) => {
            onChange(id)
            handleAddressCountrySelect(id)
          }}
          selectedId={value}
          size="sm"
        />
      )}
    />
  )
}
